/**
 * ForgeDerivedBadge — marks content (citations, modules, briefs) as
 * FORGE-derived.
 *
 * Cycle-105.8 sprint-3 (S3, g231) · FR-W-4 task 231.5. Visibility is gated by
 * the `forgeDerivedTags` workspace tweak (`useWorkspaceTweaks`); callers render
 * it only when that setting is on. Uses the existing iris/forge accent token —
 * no new visual language.
 */

import { cn } from '@/lib/utils';

export interface ForgeDerivedBadgeProps {
  className?: string;
  /** Compact mode — glyph only, no label. */
  compact?: boolean;
}

export function ForgeDerivedBadge({ className, compact = false }: ForgeDerivedBadgeProps) {
  return (
    <span
      data-testid="forge-derived-badge"
      title="FORGE-derived"
      className={cn(
        'inline-flex items-center gap-1 rounded-sm px-1.5 py-[1px] font-mono text-[9px] uppercase tracking-[0.08em]',
        className,
      )}
      style={{
        color: 'oklch(0.720 0.150 278)',
        background: 'color-mix(in oklch, oklch(0.510 0.168 278) 14%, transparent)',
        border: '1px solid color-mix(in oklch, oklch(0.510 0.168 278) 40%, transparent)',
      }}
    >
      <span aria-hidden="true">◇</span>
      {!compact && <span>FORGE</span>}
    </span>
  );
}
